<div
  (click)="readonly() ? null : $event.stopPropagation()"
  class="flex items-center gap-1"
>
  @if (small()) {
    <mat-icon
      fontIcon="numbers"
      class="opacity-50 icon-sm"
    />
  }
  <p
    [class.gap-1]="!readonly()"
    class="truncate flex items-center"
  >
    @if (!readonly()) {
      <proffeo-ui-select
        (click)="$event.stopPropagation()"
        (valueChange)="onTaskTypeChange($event)"
        [compareWith]="compareTaskTypes"
        [optionTemplate]="typeOptionTemplate"
        [options]="typeOptions()"
        [triggerTemplate]="typeTriggerTemplate"
        [value]="selectedTaskType()"
        appearance="inline"
      />
    } @else {
      <span class="font-bold">{{ selectedTaskType()?.code }}</span>
    }
    <span>-{{ taskNumber() }}</span>
  </p>
</div>

<ng-template
  #typeTriggerTemplate
  let-selectedOptions="selectedOptions"
>
  <span
    class="flex items-center font-bold justify-center px-1.5 py-1 border-proffeo-border bg-proffeo-surface-subtle border cursor-pointer rounded-md hover:bg-proffeo-surface-hover transition-default text-sm"
  >
    {{ selectedOptions[0]?.value?.code }}
  </span>
</ng-template>

<ng-template
  #typeOptionTemplate
  let-option="option"
>
  <span class="flex items-center gap-1.5">
    <span>{{ option.value.code }}</span>
    <span>{{ option.value.name }}</span>
  </span>
</ng-template>
